import { Alert } from "antd";
import { formatAssetNames } from "../../../../util/phaseRotations";

type PhaseRotationWarningProps = {
  undeclaredRotations: string[];
  className?: string;
};

export const PhaseRotationWarning: React.FC<PhaseRotationWarningProps> = ({
  undeclaredRotations,
  className,
}) => (
  <Alert
    type="warning"
    showIcon
    className={className}
    message="Phase rotations are not fully declared"
    description={`${formatAssetNames(undeclaredRotations)} in the site configuration declare${
      undeclaredRotations.length === 1 ? "s" : ""
    } no phase rotation. The controller only uses declared rotations when every collector and device declares one, so it will ignore use topology and assume the worst case for the whole site.`}
  />
);
